import { sha256 } from 'js-sha256';

const storage = localStorage;

export const hashString = (str) => sha256(str);

export const STORAGE_KEYS = {
  EQUIPMENTS: 'equipments',
  IMAGES: 'images',
  BACKGROUND: 'background',
  BANNER: 'banner',
  LOGO1: 'logo1',
  LOGO2: 'logo2',
};

export const getStorageItem = (key) => {
  try {
    const item = storage.getItem(key);
    return item ? JSON.parse(item) : null;
  } catch (error) {
    console.error(`Error reading from storage (${key}):`, error);
    return null;
  }
};

export const setStorageItem = (key, value) => {
  try {
    storage.setItem(key, JSON.stringify(value));
  } catch (error) {
    if (error.name === 'QuotaExceededError') {
      console.error(`Storage quota exceeded for key '${key}'. Consider clearing old data.`);
    }
    console.error(`Error writing to storage (${key}):`, error);
  }
};

export const removeStorageItem = (key) => {
  try {
    storage.removeItem(key);
  } catch (error) {
    console.error(`Error removing from storage (${key}):`, error);
  }
};

export const clearStorage = () => {
  try {
    storage.clear();
  } catch (error) {
    console.error('Error clearing storage:', error);
  }
};

export const getCachedData = (key, matchFn) => {
  const items = getStorageItem(key) || [];
  
  const now = new Date().getTime();
  const validItems = items.filter(item => now <= item.expiry);
  
  if (validItems.length !== items.length) {
    setStorageItem(key, validItems);
  }
  
  return validItems.find(matchFn) || null;
};

export const addToCachedData = (key, newItem, maxItems = 5) => {
  const items = getStorageItem(key) || [];
  
  if (items.length >= maxItems) {
    items.shift();
  }
  
  items.push(newItem);
  setStorageItem(key, items);
};

/**
 * Get cached image data with expiry check and detailed parameter matching
 * Specialized version for images that matches multiple query parameters
 * @param {object} params - Object containing vin, apikey, and queries
 * @param {string} params.vin - Vehicle identification number
 * @param {string} params.apikey - API key
 * @param {object} params.queries - Query parameters (night, roofOpen, background, etc.)
 * @returns {any} Matched cached item or null
 */
export const getFromCache = (params) => {
  const { vin, apikey, queries } = params;
  const { night, roofOpen, background, uniformImage, fileFormat, cropped, cropPosition, backgroundItem } = queries;
  const apikeyHash = hashString(apikey);
  
  const items = getStorageItem(STORAGE_KEYS.IMAGES) || [];
  
  const now = new Date().getTime();
  const validItems = items.filter(item => now <= item.expiry);
  
  if (validItems.length !== items.length) {
    setStorageItem(STORAGE_KEYS.IMAGES, validItems);
  }
  
  const matchedItem = validItems.find(element =>
    element.vin === vin && 
    element.apikeyHash === apikeyHash &&
    element.night === night && 
    element.roofOpen === roofOpen &&
    element.background === background && 
    element.fileFormat === fileFormat &&
    element.cropped === cropped &&
    element.cropPosition === cropPosition &&
    element.uniformImage === uniformImage &&
    element.backgroundItem === backgroundItem
  );
  
  return matchedItem || null;
};
